<template>
	<v-card>
		<v-card-title class="mt-3">
			<h1 class="ml-2">Umowy i aneksy</h1>
		</v-card-title>
		<v-container fluid>
			<v-layout>
				<v-flex xs5 class="ma-1">
					<v-card-title><h2>Umowy</h2></v-card-title>
					<v-container fluid>
						<v-layout style="position: relative">
							<v-flex ma-3 xs6>
								<v-select
									:items="templates"
									item-text="name"
									v-model="selectedTemplate"
									item-value="id"
									return-object
									aria-label="template"
									:disabled="!possibleToGenerateAgreement()"
								></v-select>
							</v-flex>
							<v-flex ml-5>
								<v-btn @click="getAgreement" :disabled="!possibleToGenerateAgreement()"
									style="float: left; margin-top: 13px;">
									Generuj umowę
								</v-btn>
							</v-flex>
						</v-layout>
						<v-layout>
							<agreement-popup v-if="project.status === 'APPROVED'" :project="project"
								v-on:refresh="refresh"/>
							<agreement-data v-if="displayAgreementData" :project="project"/>
						</v-layout>
					</v-container>
				</v-flex>
				<v-flex xs7 class="ma-1">
					<annex-application-popup
						v-on:refresh="refresh"
						:is-open="isApplicationPopupOpen"
						:edit="edit"
						:item="editedItem"
						@close="closePopup"
					/>
					<annex-popup
						v-on:refresh="refresh"
						:is-open="isAnnexPopupOpen"
						:edit="edit"
						:item="editedItem"
						@close="closePopup"
					/>

					<project-agreement-data-dialog
						v-on:refresh="refresh"
						ref="agreementDataDialog"
						:data-type="dialog.dataType"
						:annex-id="dialog.id"
					/>

					<v-card-title>
						<h2>Aneksy</h2>
						<v-spacer/>
						<h2>{{getAnnexStatus}}</h2>
					</v-card-title>


					<v-flex mt-3>
						<v-btn v-if="!project.isAwaitingAnnexSigning"
							@click="addApplication"
						>
							Dołącz wniosek o podpisanie aneksu
						</v-btn>
						<v-btn
							v-if="project.isAwaitingAnnexSigning"
							@click="addAnnex"
						>
							Dołącz aneks
						</v-btn>

					</v-flex>
					<v-container fluid>
						<v-layout>
							<v-flex>
								<v-data-table
									v-if="project.annexes.length > 0"
									:items="project.annexes"
									:headers="annexHeaders"
									:row-actions="annexActions"
									hide-actions
								>
									<template slot="items" slot-scope="props">
										<tr>
											<td>{{"Wniosek"}}</td>
											<td>{{props.item.number}}</td>
											<td>{{props.item.application.fileName}}</td>
											<td class="text-xs-center">{{props.item.applicationSignDate}}</td>
											<td>
												<v-layout>
													<egranty-icon-button
														small
														icon="edit"
														label="Edytuj"
														@click="editItem(props.item, props.index, false)"/>
													<egranty-icon-button
														small
														icon="attachment"
														label="Zarządzaj załącznikami"
														@click="openAnnexApplicationDataDialog(props.item)"/>
												</v-layout>
											</td>
										</tr>
										<tr v-if="props.item.annex !== null">
											<td>{{"Aneks"}}</td>
											<td>{{props.item.number}}</td>
											<td>{{props.item.annex.fileName}}</td>
											<td class="text-xs-center">{{props.item.signDate}}</td>
											<td>
												<v-layout>
													<egranty-icon-button
														small
														icon="edit"
														label="Edytuj"
														@click="editItem(props.item, props.index, true)"/>
													<egranty-icon-button
														small
														icon="attachment"
														label="Zarządzaj załącznikami"
														@click="openAnnexDataDialog(props.item)"/>
												</v-layout>
											</td>
										</tr>
									</template>
								</v-data-table>
							</v-flex>
						</v-layout>
					</v-container>
				</v-flex>
			</v-layout>
			<v-layout><h3>Uwagi</h3></v-layout>
			<v-layout>
				<v-flex>
					<v-textarea outline auto-grow v-model="project.annexRemarks"
						browser-autocomplete="off" aria-label="label for text"></v-textarea>
				</v-flex>
			</v-layout>
			<v-btn primary @click="updateAnnexRemarks" :disabled="project.status === 'WITHDRAWN'">Zapisz</v-btn>
		</v-container>
	</v-card>
</template>

<script>
	import {Files} from "@/utils/Files";
	import {Department} from "@/api/generated/Department";
	import AgreementPopup from "./components/AgreementPopup";
	import AgreementData from "./components/AgreementData";
	import AnnexApplicationPopup from "./components/AnnexApplicationPopup";
	import AnnexPopup from "./components/AnnexPopup";
	import {Dates} from "@/utils/Dates";
	import EgrantyIconButton from "../../../genericComponents/EgrantyIconButton";
	import {Annex} from "@/api/generated/Annex";
	import ProjectAgreementDataDialog from "./components/ProjectAgreementDataDialog";

	export default {
		name: "ProjectAgreementView",
		components: {
			ProjectAgreementDataDialog,
			EgrantyIconButton, AnnexApplicationPopup, AgreementData, AgreementPopup, AnnexPopup,
		},
		mixins: [Files, Dates],

		data() {
			return {
				templates: [],
				selectedTemplate: null,
				annexHeaders: [
					{text: "Rodzaj", sortable: false},
					{text: "Numer", sortable: false},
					{text: "Dokument", sortable: false},
					{text: "Data podpisania", sortable: false},
					{text: "Akcje", sortable: false},
				],
				annexActions: [
					{name: "downloadApplication", icon: "assignment_late", label: "Pobierz wniosek"},
					{name: "downloadAnnex", icon: "assignment_turned_in", label: "Pobierz aneks"},
				],
				edit: false,
				isApplicationPopupOpen: false,
				isAnnexPopupOpen: false,
				editedItem: {},
				dialog: {
					isOpen: false,
					dataType: "",
					id: null,
				},
			};
		},

		computed: {
			displayAgreementData() {
				return this.project.status === "AGREEMENT_SIGNED" || (this.project.status === "WITHDRAWN" || this.project.status==="FINISHED" && this.project.agreementNumber);
			},

			getAnnexStatus () {
				if (this.project.annexes.length === 0) {
					return '';
				}
				if (this.project.isAwaitingAnnexSigning) {
					return 'Status: przyjęto wniosek';
				} else {
					return 'Status: aneks podpisany';
				}
			}
		},

		methods: {

			getAgreement() {
				if (this.selectedTemplate) {
					this.downloadFileAsBlob(this, this.generateContract(this.$route.params.projectId, this.selectedTemplate.id), this.selectedTemplate.name);
				}
			},
			possibleToGenerateAgreement() {
				return this.project.status === "APPROVED";
			},

			refresh() {
				this.$emit("refresh");
			},

			downloadAnnexApplication(item) {
				this.downloadFileAsBlob(this, this.getProjectDocument(item.application.id), item.application.fileName);
			},

			downloadAnnexDocument(item) {
				this.downloadFileAsBlob(this, this.getProjectDocument(item.annex.id), item.annex.fileName);
			},

			openAnnexDataDialog (item) {
				this.dialog.id = item.id;
				this.dialog.dataType = "annex";
				this.dialog.isOpen = true;
				this.$refs.agreementDataDialog.openDialog();
			},

			openAnnexApplicationDataDialog (item) {
				this.dialog.id = item.id;
				this.dialog.dataType = "application";
				this.dialog.isOpen = true;
				this.$refs.agreementDataDialog.openDialog();
			},

			updateAnnexRemarks() {
				Annex.putAnnexRemarks(this, this.$route.params.projectId, {body: this.project.annexRemarks});
			},

			addApplication() {
				this.edit = false;
				this.editedItem = {};
				this.showApplicationPopup();
			},
			addAnnex() {
				this.edit = false;
				this.editedItem = {};
				this.showAnnexPopup();
			},
			showApplicationPopup() {
				this.isApplicationPopupOpen = true;
			},
			showAnnexPopup() {
				this.isAnnexPopupOpen = true;
			},
			closePopup() {
				this.isApplicationPopupOpen = false;
				this.isAnnexPopupOpen = false;
				this.editedItem = {};
			},
			editItem(item, index, isAnnex) {
				this.editedItem = item;
				this.editedItem.index = index;
				this.edit = true;
				if (!isAnnex) {
					this.showApplicationPopup();
				} else {
					this.showAnnexPopup();
				}
			},

		},

		props: {
			project: {
				type: Object,
			},
		},

		mounted() {
			Department.getContractTemplates(this, this.$route.params.contestId, success => {
				this.templates = success;
			});
		},
	};
</script>

<style scoped>

</style>
